<div class="selectedLayesSideTree"  >
<!-- 
<p-accordion *ngFor="let node of nodes" multiple="true" (onClose)="onClose(node)" (onOpen)="onOpen(node)">
    <p-accordionTab *ngIf="(node.data.showlegend !== undefined && node.data.showlegend)"  [selected]="true" >
    <p-header>
   
       		{{node.label}}  
       
    </p-header>
    <div class="{{node.data.aclass}}">
    <div class="btnholder">
	  
	    <p-toggleButton   (onChange)="hide(node)" class="aToggleButton" onLabel="" offLabel="" onIcon="fa fa-eye" offIcon="fa fa-eye" ></p-toggleButton>
	     <div   (click)="$event.stopPropagation();remove($event , node)" class="aToggleButton fa fa-window-close"></div>
	   
	   
    </div>
   
     <img src="{{node.data.legend}}"/>
      
    </div>
    </p-accordionTab>
</p-accordion>
 -->
 <div *ngIf="nodes.length > 0" class="legendContainer">
 
	 
		 <div class="legendTitle">LEGENDA</div>
		
		<div class="legendScrollDiv">
		
		 <div class="legendItem" *ngFor="let node of nodes"   >
		 	<div  *ngIf="(node.data.showlegend !== undefined && node.data.showlegend)" class="{{node.data.aclass}}">	
		 	<div class="legendItemHeader">
		 		
		 		<div class="legendLabel">{{node.label}}</div>

		 		
		 		<div class="controlsDiv">
		 			<span *ngIf="canExport(node)" class="legendExport">
		 				<button type="button" class="legendExportBtn"
		 					pTooltip="Izvoz v GeoPackage" tooltipPosition="left"
		 					tooltipZIndex="99999" showDelay="600"
		 					(click)="doExport($event, node, 'gpkg')">GPKG</button>
		 				<button type="button" class="legendExportBtn"
		 					pTooltip="Izvoz v GeoTIFF" tooltipPosition="left"
		 					tooltipZIndex="99999" showDelay="600"
		 					(click)="doExport($event, node, 'tif')">TIF</button>
		 			</span>
					
		 			<p-toggleButton
					styleClass="iconBtn"
					pTooltip="Prikaži/skrij sloj"
					tooltipPosition="left"
					tooltipZIndex="99999"
					showDelay="1000"
					(onChange)="hide(node)"
					onLabel=""
					offLabel=""
					onIcon="pi pi-eye-slash"
					offIcon="pi pi-eye">
					</p-toggleButton>
			    	<div pTooltip="Odstrani sloj" tooltipPosition="left" tooltipZIndex="99999" showDelay="1000"  (click)="$event.stopPropagation();remove($event , node)" class="aToggleButton2 pi pi-times"></div>
			    </div>
			    
			    <div class="underline"></div>
		 	</div>
		 	
		 	<div *ngIf="(node.data.ison)" class="legendItemBody">
		 	
		 		<img src="{{node.data.legend}}"/>
		 		
		 	</div>
		 	</div>
		 </div>
	
		</div>
				 
		 <div class="closeBar" (click)="setHiddenLegend(true)">
		 	<img src="./assets/img/rightArrow.png"/>
		 </div>
 


</div>
